import React from 'react';
import classnames from 'classnames';

import StrapiButton from '../../StrapiLink/StrapiButton';
import { RichTextField } from '../../RichTextField/RichTextField';
import { ColumnsComponentFragment, LinkComponentFragment, Maybe } from '../../../../graphql.schema';

type ColumnsComponentFragmentProps = ColumnsComponentFragment & {
  optional_link: Maybe<{ __typename?: 'Strapi_ComponentAtomLink' } & LinkComponentFragment>;
};

export const StrapiColumnsComponent: React.FC<ColumnsComponentFragmentProps> = ({
  heading,
  description,
  columns,
  showColumnIndex,
  optional_link: link,
}) => {
  const isV2 = process.env.GATSBY_IS_V2 === 'true';
  let styles = require('./index.module.scss');
  if (isV2) {
    styles = require('./index-v2.module.scss');
  }

  return (
    <div className={styles.columnsComponent}>
      {heading || description ? (
        <div className={styles.columnsComponentHeader}>
          {heading ? <h2 className={classnames('title', styles.columnsComponentHeading)}>{heading}</h2> : null}
          {description ? (
            <RichTextField className={styles.columnsComponentDescription} content={`<p>${description}</p>`} />
          ) : null}
          {link && <StrapiButton type="secondary" key={link?.title} {...(link as LinkComponentFragment)} />}
        </div>
      ) : null}
      <div className={styles.columnsComponentColumns}>
        {columns?.map((column, idx) => {
          if (!column) return null;
          return (
            <div key={`column-${idx}`} className={styles.columnsComponentColumn}>
              {column.title && (
                <div className={styles.columnsComponentColumnHeader}>
                  <h3 className={classnames('title is-3')}>{column.title}</h3>
                  <span className={classnames('has-text-weight-light', styles.columnsComponentColumnIndex)}>
                    {showColumnIndex && idx + 1}
                  </span>
                </div>
              )}
              <RichTextField content={column.content} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
